export const selectHasShops = state =>
  Object.keys(state.shop.entities.stores).length > 0;

export const selectCustomerShopsIds = state =>
  state.shop.entities.customerShops || [];

export const selectShops =
  (shopIds = []) =>
  state =>
    shopIds.map(shopId => state.shop.entities.stores[shopId]).filter(i => i);

export const selectShopsByErpId =
  (shopIds = []) =>
  state =>
    Object.values(state.shop.entities.stores).filter(store =>
      shopIds.includes(store.erpStoreId),
    );

export const selectIsFetchingShops = state => state.shop.isFetchingShops;

export const selectIsFetchingCustomerShops = state =>
  state.shop.isFetchingCustomerShops;

export const selectShop = shopId => state =>
  state.shop.entities.stores[shopId] || {};

export const selectSizesInShop = (shopId, productColorId) => state =>
  state.shop.entities.availability?.[shopId]?.[productColorId]?.sizes || [];

export const selectProductAvailability =
  (shopId, productColorId, sizeId) => state => {
    const sizes = selectSizesInShop(shopId, productColorId)(state);
    const { availability } = sizes.find(size => size.title === sizeId) || 0;

    return availability;
  };

export const selectIsProductSizeAvailableInCustomerShops =
  (productColorId, sizeId) => state =>
    state.shop.entities.customerShops.some(customerShopId => {
      const availability = selectProductAvailability(
        customerShopId,
        productColorId,
        sizeId,
      )(state);

      return availability > 0;
    });

export const selectProductInShops = (shopIds, productColorId) => state =>
  shopIds.map(
    shopId =>
      state.shop.entities.availability?.[shopId]?.[productColorId]?.sizes || [],
  );

export const selectProductsInShop = shopId => state =>
  state.shop.entities.availability[shopId] || {};

export const selectIsProductAvailableInCustomerShops =
  productColorId => state => {
    const customerShopsIds = selectCustomerShopsIds(state);

    return customerShopsIds.some(shopId => {
      const products = selectProductsInShop(shopId)(state);

      return Object.entries(products).some(([id, { sizes }]) => {
        if (id !== productColorId) return false;

        return sizes.some(({ availability }) => availability > 0);
      });
    });
  };

export const selectShopsGroupedAlphabetically = state =>
  Object.fromEntries(
    Object.entries(state.shop.entities.groupedAlphabetically || {}).map(
      ([char, stores]) => [char, selectShops(stores)(state)],
    ),
  );
